import { Injectable, signal } from '@angular/core';
import { AurToastConfig } from '@shared/models/core-component.models';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private seq = 0;
  readonly toasts = signal<AurToastConfig[]>([]);

  push(config: AurToastConfig): void {
    const id = config.id ?? `toast-${++this.seq}`;
    const next: AurToastConfig = {
      intent: 'neutral',
      variant: 'raised',
      dismissible: true,
      icon: 'circle-solid',
      ...config,
      id,
    };
    this.toasts.update((list) => [...list, next]);
    window.setTimeout(() => this.dismiss(id), 4200);
  }

  dismiss(id: string | undefined): void {
    if (!id) return;
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  clear(): void {
    this.toasts.set([]);
  }
}
